import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

const base = 'affiliates'

AdminRouter.addRoutes([
  {
    name: `${base}`,
    path: `/${base}`,
    component: () => import('./Index.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `${base}.payouts`,
    path: `/${base}/payouts/:user_id`,
    component: () => import('./Payouts.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `${base}.deferred_payments`,
    path: `/${base}/deferred-payments/:user_id`,
    component: () => import('./DeferredPayments.vue'),
    meta: {
      auth: true,
    },
  },
])

AdminSidebar.pushItem({
  id: `${base}`,
  order: 60,
  header: $vm => $vm.$t(`general.menu_management`),
  text($vm) {
    return $vm.$t(`${base}.title`)
  },
  route: {
    name: `${base}`,
  },
  icon: 'icon-tree5',
  permission: 'users.affiliates',
})

messageGroups.push(base)
messageGroups.push('deferred_payments')
